/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../payment/payment.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../app/shared/components/social-login-button/facebook/social-login-button.facebook.component';
import * as i6 from 'angular2-social-login/dist/auth.service';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../../app/payment/services/identification-steps.service';
const styles_SocialLoginButtonFacebookComponent:any[] = [i0.styles];
export const RenderType_SocialLoginButtonFacebookComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SocialLoginButtonFacebookComponent,data:{}});
function View_SocialLoginButtonFacebookComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'col btn btn-sm btn-fb'],['role','button'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.fbLogin()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'i',[['class','fa fa-facebook-square mr-sm']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(3,(null as any),['','\n'])),i1.ɵpid(131072,i2.TranslatePipe,
          [i3.TranslateService,i1.ChangeDetectorRef])],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform('PAYMENT.IDENTIFICATION.IDENTIFICATION.CONNECT_WITH_FB'));
    _ck(_v,3,0,currVal_1);
  });
}
export function View_SocialLoginButtonFacebookComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SocialLoginButtonFacebookComponent_1)),i1.ɵdid(1,16384,(null as any),0,
      i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],
      (_ck,_v) => {
        var _co:i5.SocialLoginButtonFacebookComponent = _v.component;
        const currVal_0:any = _co.allowed;
        _ck(_v,1,0,currVal_0);
      },(null as any));
}
export function View_SocialLoginButtonFacebookComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'social-login-button-facebook',
      ([] as any[]),(null as any),(null as any),(null as any),View_SocialLoginButtonFacebookComponent_0,
      RenderType_SocialLoginButtonFacebookComponent)),i1.ɵdid(1,49152,(null as any),
      0,i5.SocialLoginButtonFacebookComponent,[i6.AuthService,i7.ActivatedRoute,i8.IdentificationStepsService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const SocialLoginButtonFacebookComponentNgFactory:i1.ComponentFactory<i5.SocialLoginButtonFacebookComponent> = i1.ɵccf('social-login-button-facebook',
    i5.SocialLoginButtonFacebookComponent,View_SocialLoginButtonFacebookComponent_Host_0,
    {disabled:'disabled'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NvY2lhbC1sb2dpbi1idXR0b24vZmFjZWJvb2svc29jaWFsLWxvZ2luLWJ1dHRvbi5mYWNlYm9vay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM1NjA1OTk2NDQvc3JjL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvc29jaWFsLWxvZ2luLWJ1dHRvbi9mYWNlYm9vay9zb2NpYWwtbG9naW4tYnV0dG9uLmZhY2Vib29rLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NvY2lhbC1sb2dpbi1idXR0b24vZmFjZWJvb2svc29jaWFsLWxvZ2luLWJ1dHRvbi5mYWNlYm9vay5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NvY2lhbC1sb2dpbi1idXR0b24vZmFjZWJvb2svc29jaWFsLWxvZ2luLWJ1dHRvbi5mYWNlYm9vay5jb21wb25lbnQudHMuU29jaWFsTG9naW5CdXR0b25GYWNlYm9va0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxidXR0b24gY2xhc3M9XCJjb2wgYnRuIGJ0bi1zbSBidG4tZmJcIiB0eXBlPVwiYnV0dG9uXCIgcm9sZT1cImJ1dHRvblwiXG4gICAgICAgICpuZ0lmPVwiYWxsb3dlZFwiXG4gICAgICAgIChjbGljayk9XCJmYkxvZ2luKClcIlxuICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIj5cbiAgICA8aSBjbGFzcz1cImZhIGZhLWZhY2Vib29rLXNxdWFyZSBtci1zbVwiPjwvaT57e1wiUEFZTUVOVC5JREVOVElGSUNBVElPTi5JREVOVElGSUNBVElPTi5DT05ORUNUX1dJVEhfRkJcIiB8IHRyYW5zbGF0ZX19XG48L2J1dHRvbj4iLCI8c29jaWFsLWxvZ2luLWJ1dHRvbi1mYWNlYm9vaz48L3NvY2lhbC1sb2dpbi1idXR0b24tZmFjZWJvb2s+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFUTtNQUFBO01BQUE7SUFBQTtJQUZSO0VBQUEsZ0NBRzhCLDhDQUMxQjthQUFBO1VBQUE7TUFBMkM7VUFBQTs7SUFEdkM7SUFIUixXQUdRLFNBSFI7SUFJK0M7SUFBQTs7OztvQkFKL0M7TUFBQSxtREFBQTtjQUFBOzs7UUFDUTtRQURSLFdBQ1EsU0FEUjs7OztvQkNBQTtNQUFBO21EQUFBLFVBQUE7TUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/app/shared/components/social-login-button/facebook/social-login-button.facebook.component.ngfactory.ts